import { vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "radio-group primary h-100"
}
const _hoisted_2 = { class: "radio-buttons gap-20 h-100 flex-column flex-md-row" }
const _hoisted_3 = { class: "radio-button enlarged bordered-card bordered-card_secondary flex-1 h-100 align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "admin_auth" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Administrator"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("small", { class: "fw-light" }, "Authentication/PIN Request"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("In order to register your local for the first time, choose this option to begin the process.")
], -1)
const _hoisted_5 = { class: "radio-button enlarged bordered-card bordered-card_secondary flex-1 h-100 align-items-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "admin_register" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Administrator"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("small", { class: "fw-light" }, "Registration (Registration Requires PIN)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Once you have received your PIN, register here as the Administrator. ")
], -1)
const _hoisted_7 = { class: "radio-button enlarged bordered-card bordered-card_secondary flex-1 h-100 align-items-start" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "rep_register" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Representative"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("small", { class: "fw-light" }, "Registration (Registration Requires PIN)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" As a Registrant of your Local, as designated by the Local’s Administrator, choose this option to register using you assigned PIN. ")
], -1)
const _hoisted_9 = {
  key: 1,
  class: "radio-group primary h-100"
}
const _hoisted_10 = { class: "radio-buttons gap-20 h-100 flex-column flex-md-row" }
const _hoisted_11 = { class: "radio-button enlarged bordered-card bordered-card_secondary flex-1 h-100 align-items-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "admin_auth" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Administrator"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("small", { class: "fw-light" }, "Authentication/PIN Request"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("In order to register your Employer for the first time, choose this option to begin the process.")
], -1)
const _hoisted_13 = { class: "radio-button enlarged bordered-card bordered-card_secondary flex-1 h-100 align-items-start" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "admin_register" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Administrator"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("small", { class: "fw-light" }, "Registration (Registration Requires PIN)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Once you have received your PIN, register here as the Administrator. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.selectedUserType == 5 || _ctx.selectedUserType == 3)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.type) = $event)),
              type: "radio",
              id: "admin_auth",
              value: "auth"
            }, null, 512), [
              [_vModelRadio, _ctx.type]
            ]),
            _hoisted_4
          ]),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "admin_register",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.type) = $event)),
              value: "register"
            }, null, 512), [
              [_vModelRadio, _ctx.type]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              id: "rep_register",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.type) = $event)),
              value: "rep_register"
            }, null, 512), [
              [_vModelRadio, _ctx.type]
            ]),
            _hoisted_8
          ])
        ])
      ]))
    : (_ctx.selectedUserType == 6 || _ctx.selectedUserType == 7)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event)),
                type: "radio",
                id: "admin_auth",
                value: "auth"
              }, null, 512), [
                [_vModelRadio, _ctx.type]
              ]),
              _hoisted_12
            ]),
            _createElementVNode("div", _hoisted_13, [
              _withDirectives(_createElementVNode("input", {
                type: "radio",
                id: "admin_register",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.type) = $event)),
                value: "register"
              }, null, 512), [
                [_vModelRadio, _ctx.type]
              ]),
              _hoisted_14
            ])
          ])
        ]))
      : _createCommentVNode("", true)
}